// Requires momentjs

if (typeof cpac !== 'undefined') {
    cpac.packages = {
        constants: {
            auto_renew_types: {
                expiration_usage: 'expiration_and_usage',
                expiration: 'expiration_only'
            },
            expiration_types: {
                by_date: 'by_date',
                by_duration: 'by_duration'
            },
            duration_types: {
                days: 'days',
                weeks: 'weeks',
                months: 'months'
            }
        },
    
        buy:{
            formId:'buy_package',
            privateLessonContainerSelector: '.private_lesson_info',
            groupActivityContainerSelector: '.group_activity_info',
    
            getCurrentLocation: function() {
                return $j('#location').val();
            },
    
            getCurrentComponent:function () {
                return $j('#component').val();
            },
    
            getCurrentUserId: function() {
                return $j('#user_id').val();
            },
    
            getSaleChannel: function() {
                return $j('input[name="sale_channel"]').val();
            },
    
            hidePrivateLessonInfo: function () {
                $j(this.privateLessonContainerSelector).hide();
                //clear total price memo
                $j('.package_total_price').html('');
                $j('#private_lesson_purchase_form').html('');
            },
    
            showPrivateLessonInfo: function() {
                $j(this.privateLessonContainerSelector).show();
                $j('#package_type').val('any_pro');
                $j('#package_type').trigger('chosen:updated');
                $j('#packages_list').html('');
                $j('#private_lesson_purchase_form').show();
    
                cpac.packages.buy.selectPrivateLessonType(); // select Any Pro
            },
    
            hideGroupActivityInfo: function() {
                $j(this.groupActivityContainerSelector).html('');
                $j(this.groupActivityContainerSelector).hide();
            },
    
            showGroupActivityInfo: function(content) {
                var $container = $j(this.groupActivityContainerSelector);
                $container.html(content);
                $container.show();
            },
    
            showPackageList: function(content, selectedItemId) {
                $j('#buyPackage .selected_row').removeClass('selected_row');
                $j('#buyPackage .selected_row_id').val('0');
                var $container = $j('#component_activities_list_container');
                $container.html(content);
    
                if (selectedItemId) {
                    $j('#component_activities_list_container a').each(function() {
                        if ($j(this).attr('id') === selectedItemId) {
                            $j(this).trigger('click');
                        }
                    });
                }
            },
    
            selectComponentLocation: function() {
                /* on Club Location/Department drop-down selection */
                var self = this;
                var selectedLocation = cpac.packages.buy.getCurrentLocation();
                var selectedComponent = cpac.packages.buy.getCurrentComponent();
                var userId = cpac.packages.buy.getCurrentUserId();
                var saleChannel = cpac.packages.buy.getSaleChannel();
    
                cpac.packages.buy.hidePrivateLessonInfo();
                cpac.packages.buy.hideGroupActivityInfo();
    
                if ($j.isNumeric(selectedComponent)) {
                    // show component's group activities
                    $j.caAjax({
                        url: '/package/get-component-activities-list',
                        type: 'post',
                        dataType: 'json',
                        loadingSplash: true,
                        data: {
                            location_id: selectedLocation,
                            component_id: selectedComponent,
                            sale_channel: saleChannel,
                        },
                        success: function (response) {
                            if (response.status === 1) {
                                self.showPackageList(response.content);
                            } else {
                                $j.caAlert(response.message);
                            }
                        }
                    });
                } else if (selectedComponent === 'guest_pass') {
                    // guest pass form
                    $j.caAjax({
                        url: '/package/get-guest-pass-package-form',
                        type: 'post',
                        dataType: 'json',
                        loadingSplash: true,
                        data: {
                            user_id: userId,
                            sale_channel: saleChannel,
                        },
                        success: function (response) {
                            if (response.status === 1) {
                                self.showPackageList(response.package_list, 'row_component_activities_list_guest_pass');
                                self.showGroupActivityInfo(response.content);
                            } else {
                                $j.caAlert(response.message);
                            }
                        }
                    });
                }
            },
    
            selectPackage: function() {
                /* On Group Ex Package selection */
                try {
                    var self = this;
                    var selectedPackage = $j('#component_activities_list').val();
                    var userId = cpac.packages.buy.getCurrentUserId();
                    var saleChannel = cpac.packages.buy.getSaleChannel();
    
                    cpac.packages.buy.hidePrivateLessonInfo();
                    cpac.packages.buy.hideGroupActivityInfo();
    
                    if ($j.isNumeric(selectedPackage)) {
                        // group ex
                        $j.caAjax({
                            url: '/package/get-group-ex-package-form',
                            type: 'post',
                            dataType: 'json',
                            loadingSplash: true,
                            data: {
                                user_id: userId,
                                package_id: selectedPackage,
                                sale_channel: saleChannel,
                            },
                            success: function (response) {
                                if (response.status === 1) {
                                    self.showGroupActivityInfo(response.content);
                                } else {
                                    $j.caAlert(response.message);
                                }
                            }
                        });
                    } else if (selectedPackage.indexOf('lesson_') !== -1) {
                        self.showPrivateLessonInfo();
                    }
                } catch (e) {
                    cpac.error(e);
                }
    
                if (modalWin) {
                    modalWin.updateHeight();
                }
            },
    
            selectPrivateLessonType: function(item) {
                var locationId = cpac.packages.buy.getCurrentLocation();
                var componentId = cpac.packages.buy.getCurrentComponent();
                var userId = cpac.packages.buy.getCurrentUserId();
                var saleChannel = cpac.packages.buy.getSaleChannel();
                var packageType = $j('#package_type').val();
    
                $j('.package_types').hide();
                $j('#packages_list').html('');
                $j('#private_lesson_purchase_form').html('');
    
                if (packageType === 'custom') {
                    // custom lesson package
                    $j.caAjax({
                        url: '/package/get-custom-package-form',
                        type: 'post',
                        dataType: 'json',
                        loadingSplash: true,
                        data: {
                            location_id: locationId,
                            component_id: componentId,
                            user_id: userId,
                            sale_channel: saleChannel,
                        },
                        success: function (response) {
                            if (response.status === 1) {
                                $j('#private_lesson_purchase_form').html(response.content);
                            } else {
                                $j.caAlert(response.message);
                            }
                        }
                    });
                } else if (packageType !== 'custom' && packageType !== '0' && componentId) {
                    $j('body').caLoadingSplash('show');
                    // we need to load list of packages
                    var params = {};
                    params.location_id = locationId;
                    params.component_id = componentId;
                    params.sale_channel = saleChannel;
                    params.ajax = true;
                    params.package_type = packageType;
                    params.user_id = userId;
                    if (packageType === 'staff_level') {
                        params.staff_level  = $j(item).val();
                    }
                    if (packageType === 'pro') {
                        params.staff_id = item;
                    }
                    $j.ajax({
                        type: 'post',
                        url: '/package/get-packages-list',
                        data: params,
                        success: function(response){
                            $j('body').caLoadingSplash('hide');
                            $j('#packages_list').html(response);
                        }
                    });
                    $j('.'+ packageType).show();
                }
            },
    
            selectPrivateLesson: function (obj) {
                var userId = $j(obj).attr('data-user-id');
                var packageId = $j(obj).attr('data-package-id');
                var rateId = $j(obj).attr('data-rate-id');
                var saleChannel = cpac.packages.buy.getSaleChannel();
    
                selectProgram(packageId + '_' + rateId, 'individual_package', '');
    
                $j.caAjax({
                    url: '/package/get-private-lesson-package-form',
                    type: 'post',
                    dataType: 'json',
                    loadingSplash: true,
                    data: {
                        user_id: userId,
                        package_id: packageId,
                        rate_id: rateId,
                        sale_channel: saleChannel,
                    },
                    success: function (response) {
                        if (response.status === 1) {
                            $j('#private_lesson_purchase_form').html(response.content);
                        } else {
                            $j.caAlert(response.message);
                        }
                    }
                });
            },
    
            purchasePackage: function() {
                var purchaseForm = $j('#' + cpac.packages.buy.formId);
    
                var selectedComponent = cpac.packages.buy.getCurrentComponent();
                var selectedPackage = $j('#component_activities_list').val();
    
                if (selectedComponent !== 'guest_pass' && selectedPackage <= 0) {
                    $j.caAlert('Please select a package');
                    return false;
                }
    
                $j.caAjax({
                    url: '/package/save-purchased-package',
                    type: 'post',
                    dataType: 'json',
                    loadingSplash: true,
                    data: purchaseForm.serialize(),
                    success: function (response) {
                        if (response.status === 1) {
                            $j.caDialogCloseAll();
                            switch (response.sale_channel) {
                                case 'pos' :
                                    showResources($j('#pos_form'), '/payment/right-side-view', 'pos_right_block', function() {}, 'buyPackageSuccess=1');
                                    break;
                                case 'profile' :
                                default :
                                    $j('#profile-menu a[cid=memberships]').trigger('click');
                                    break;
                            }
                        } else if (response.message !== '') {
                            $j.caAlert(response.message);
                        } else if (response.confirm !== '') {
                            $j.caConfirm(
                                response.confirm,
                                'Confirm',
                                'Yes',
                                'No',
                                function() {
                                    $j('#purchase_confirm').val(1);
                                    cpac.packages.buy.purchasePackage();
                                }
                            );
                        }
                    }
                });
            },
        },
    
        edit: {
            changeAutoRenew: function(obj) {
                if ($j(obj).is(':checked')) {
                    $j('#auto_renew_price_tr').show();
                    $j('.auto_renew_type_block').show();
                    $j('#auto_renew_renewals_tr').show();
                    $j('#auto_renew_expiration_tr').show();
                    $j('#start_date_label').text('Cycle Start');
                    $j('#expiration_date_label').text('Cycle End');
                    $j('#carry_over_session_row').show();
                } else {
                    $j('#auto_renew_price_tr').hide();
                    $j('.auto_renew_type_block').hide();
                    $j('#auto_renew_renewals_tr').hide();
                    $j('#auto_renew_expiration_tr').hide();
                    $j('#start_date_label').text('Start Date');
                    $j('#expiration_date_label').text('Expiration Date');
                    $j('#carry_over_session_row').hide();
                }
            },

            changeCarryOverSession: function (obj) {
                if ($j(obj).is(':checked')) {
                    $j('#session_carry_over_row').show();
                    $j('#session_carry_over_never').show();
                    $j('#carried_over_sessions_expire_date').show();
                } else {
                    $j('#session_carry_over_row').hide();
                    $j('#session_carry_over_never').hide();
                    $j('#carried_over_sessions_expire_date').hide();
                }
            },


            changeAutoRenewExpirationNone: function(obj) {
                if ($j(obj).is(':checked')) {
                    $j('.expiration_duration_count_block').hide();
                    $j('.expiration_duration_type_block').hide();
                }  else {
                    $j('.expiration_duration_count_block').show();
                    $j('.expiration_duration_type_block').show();
                }
            },
    
            changeAutoRenewUnlimited: function(obj) {
                if ($j(obj).is(':checked')) {
                    $j('.auto_renew_count_block').hide();
                }  else {
                    $j('.auto_renew_count_block').show();
                }
            },
    
            updateEditPackageFieldsDisplay: function() {
                $j('[name="data\[auto_renew\]"]').trigger('change');
                $j('[name="data\[auto_renew_unlimited\]"]').trigger('change');
                $j('[name="data\[auto_renew_expiration_none\]"]').trigger('change');
                $j('[name="data\[session_carry_over_enabled\]"]').trigger('change');
            }
        },
    
        select_location:function(package_id) {
    
            var clubs = new Array();
            x = 0;
            $j('#data-club').find("input").each(function (index, element) {
                if (element.checked) {
                    clubs[x] = $j(element).val();
                    x++;
                }
            });
    
            var options = {
                entity_id:    clubs,
                component_id: $j('#data-component_id').val(),
                package_id:   package_id
            };
    
            $j.caAjaxInModal('/package/select-location', options, 'Select Location', 500, 350);
        },
    
        summary:{
            actionChange:function (selectObj) {
                var name = selectObj.name;
                var selectedValue = selectObj.options[selectObj.selectedIndex].value;
                var allClass = name + '-all';
                var curClass = name + '-' + selectedValue;
    
                $j('.' + allClass).css({'display':'none'});
                $j('.' + curClass).css({'display':''});
                modalWin.updateHeight();
            }
        },
    
        change_price:function(obj) {
            find_hidden = $j(obj).closest("td").find('input.override_price');
            hidden_value = find_hidden.val();
            if (hidden_value != 1) {
                $j.caConfirm('If there are packages set to auto-renew at the current rate, would you like to apply the new rate to the existing packages ?', 'Confirm', 'Yes', 'No', function () {}, function () { find_hidden.val(1); });
            }
        },

        calcExpirationDate: function (startDate, addCount, addType, dateFormat) {
            var res = startDate !== ''
                ? cpacDate.getDateObject(startDate, dateFormat)
                : new Date();
            addCount = parseInt(addCount);

            switch (addType) {
                case cpac.packages.constants.duration_types.days:
                    res = moment(res).add(addCount, 'days');
                    break;
                case cpac.packages.constants.duration_types.weeks:
                    res = moment(res).add(addCount, 'weeks');
                    break;
                case cpac.packages.constants.duration_types.months:
                    res =  moment(res).add(addCount, 'months');
                    break;
            }
            // we need to reduce calculated duration by 1 day to let the script
            // executed at the next day after expiration date
            // calculate new valid expiration
            res = moment(res).add(-1, 'days');

            return moment(res).format(dateFormat.toUpperCase());
        }
    }
}